<script>
import { mapGetters } from 'vuex';
import { useAlert, useTrack } from 'dashboard/composables';
import CsatDashboard from './components/csat/CsatDashboard.vue';
import ReportFilterSelector from './components/FilterSelector.vue';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import CSATReports from 'dashboard/api/csatReports';
import ReportDownloadMenu from './components/ReportDownloadMenu.vue';
import { downloadBinaryFile } from 'dashboard/helper/downloadHelper';

export default {
  name: 'CsatResponses',
  components: {
    CsatDashboard,
    ReportFilterSelector,
    ReportDownloadMenu,
  },
  data() {
    return {
      pageIndex: 0,
      from: 0,
      to: 0,
      userIds: [],
      inbox: null,
      team: null,
      rating: null,
      conversationDirection: false,
      comunicanteCampaign: 'all',
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isFeatureEnabledOnAccount: 'accounts/isFeatureEnabledonAccount',
      responses: 'csat/getCSATResponses',
      metrics: 'csat/getMetrics',
      uiFlags: 'csat/getUIFlags',
      satisfactionScore: 'csat/getSatisfactionScore',
      responseRate: 'csat/getResponseRate',
    }),
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
        user_ids: this.userIds,
        inbox_id: this.inbox,
        team_id: this.team,
        rating: this.rating,
        conversationDirection: this.conversationDirection,
        comunicanteCampaign: this.comunicanteCampaign,
      };
    },
    isTeamsEnabled() {
      return this.isFeatureEnabledOnAccount(
        this.accountId,
        FEATURE_FLAGS.TEAM_MANAGEMENT
      );
    },
  },
  methods: {
    getAllData() {
      try {
        this.$store.dispatch('csat/getMetrics', this.requestPayload);
        this.getResponses();
      } catch {
        useAlert(this.$t('REPORT.DATA_FETCHING_FAILED'));
      }
    },
    getResponses() {
      this.$store.dispatch('csat/get', {
        page: this.pageIndex + 1,
        ...this.requestPayload,
      });
    },
    async downloadXlsx() {
      const response = await CSATReports.downloadXlsx(this.requestPayload);
      return downloadBinaryFile(
        'relatorio-csat.xlsx',
        response.data,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
    },
    onPageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getResponses();
    },
    onFilterChange({
      from,
      to,
      selectedAgents,
      selectedInbox,
      selectedTeam,
      selectedRating,
      selectedComunicanteCampaign,
      selectedConversationDirection,
    }) {
      // do not track filter change on inital load
      if (this.from !== 0 && this.to !== 0) {
        useTrack(REPORTS_EVENTS.FILTER_REPORT, {
          filterType: 'date',
          reportType: 'csat',
        });
      }

      this.from = from;
      this.to = to;
      this.userIds = selectedAgents.map(el => el.id);
      this.inbox = selectedInbox?.id;
      this.team = selectedTeam?.id;
      this.rating = selectedRating?.value;
      this.conversationDirection = selectedConversationDirection.id;
      this.comunicanteCampaign = selectedComunicanteCampaign.id;
      this.pageIndex = 0;
      this.getAllData();
    },
  },
};
</script>

<template>
  <div class="flex-1 p-4 overflow-auto">
    <ReportFilterSelector
      show-agents-filter
      show-inbox-filter
      show-rating-filter
      :show-team-filter="isTeamsEnabled"
      :show-business-hours-switch="false"
      @filter-change="onFilterChange"
    />
    <ReportDownloadMenu
      class="button--fixed-top"
      :xlsx-handler="downloadXlsx"
    />
    <div>
      <CsatDashboard
        :filters="requestPayload"
        :metrics="metrics"
        :responses="responses"
        :page-index="pageIndex"
        :satisfaction-score="satisfactionScore"
        :response-rate="responseRate"
        :is-fetching="uiFlags.isFetching"
        :is-fetching-metrics="uiFlags.isFetchingMetrics"
        @page-change="onPageNumberChange"
      />
    </div>
  </div>
</template>
